import { PeppolStatus } from "InvoiceV2/components/Peppol/PeppolStatus";
import React from "react";

interface Props {
  compliance: server.dto.EInvoiceSenderCompliance;
}

const error: server.dto.EInvoiceSenderCompliances[] = [
  "companyInformationMissing",
  "countryNotSupported",
];

const info: server.dto.EInvoiceSenderCompliances[] = [
  "readyForPeppolRegistration",
  "notRegisteredReferToBookkeepingPage",
];

const success: server.dto.EInvoiceSenderCompliances[] = [
  "isRegistered",
];
export const EInvoiceSenderComplianceMessage = (props: Props) => {
  let icon: "ok" | "warning" | "error";
  if (error.includes(props.compliance.value)) {
    icon = "error";
  } else if (info.includes(props.compliance.value)) {
    icon = "warning";
  } else if (success.includes(props.compliance.value)) {
    icon = "ok";
  }

  return <PeppolStatus icon={icon!} label={props.compliance.message} subLabel={props.compliance.messageSublabel} />
}